import {
  DataSources,
  ExternalAccount,
  ImportedData,
  OtherData,
  OutcomeReasons,
  ReasonCodes,
  Tags,
  YourCustomer,
  CustomFieldsCard,
} from '../cards';
import { Row, Col } from '../common';

export const ExternalAccountCreatedOverview = () => (
  <Row>
    <Col>
      <ExternalAccount />
      <YourCustomer useExistingPiiOnly />
      <ImportedData />
      <OtherData />
    </Col>
    <Col>
      <OutcomeReasons />
      <Tags />
      <ReasonCodes />
      <DataSources />
      <CustomFieldsCard />
    </Col>
  </Row>
);
